<template>
  <div class="breadcrumbBox">
    <i class="icon icon-breadcrumb"></i>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="item in breadcrumb"
        :to="item.url ? { path: item.url, query: item.query } :''"
        :key="item.label"
      >
        {{ item.label }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>

</template>

<script>
export default {
  computed: {
    breadcrumb () {
      return this.$store.state.breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbBox {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 14px;
  background-color: #eeeeee;
  padding-left: 20px;
  .el-breadcrumb {
    margin-left: 6px;
  }
}
</style>